import type { FileResponse } from '../types/file-response'
import type { SurveyResponse } from '../types/survey-response'
import type { JourneyItem } from './journey-item'
import type { JourneyStatus } from './journey-status'
import { ContractGeneric } from '@/data/schema/contract'

export class Journey extends ContractGeneric {
	object = 'JourneyHeader'
	site_contact_name = ''
	site_contact_telephone = ''
	customer_contact_name = ''
	customer_contact_telephone = ''
	delivery_address = ''
	delivery_postcode = ''
	delivery_method = ''
	delivery_time = ''
	driver_id = ''
	driver_status = '0'
	items: Array<JourneyItem> = []
	files: FileResponse[] = []
	journey_number = null
	signature?: string = ''
	signature_name = ''
	status: Array<JourneyStatus> = []
	what_3_words = ''
	driver_notes = ''
	site_arrive_at: Date | null = null
	load_start_at: Date | null = null
	site_depart_at: Date | null = null
	photos: File[] | FileResponse[] = []
	photo_skip_reason = ''
	photo_skip_reason_other = ''
	survey_skip_reason? = ''
	survey: SurveyResponse[] = []
	complete? = false
	step_number?: number | null = null
	vehicle_registration?: string | null = null
	vehicle_display_name?: string | null = null
	vehicle_name?: string | null = null
	type_name?: string | null = null
}
